import React from "react";

export default function CTISPackageBuilderPage() {
  return (
    <>
      <h1 className="h3 mb-3">CTIS Package</h1>
      <p className="text-muted">Placeholder page for CTIS templates management.</p>
    </>
  );
}